import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import {
  getRetailList,
  downloadStockBreakToXlsx,
  getBreakProductsByRetailId,
  getStockBreakGrid,
  getRetailStoreList
} from '@/app/stock_break/Services'

export const NAMESPACE = 'stockBreak/'

const _types = {
  getters: {
    DEFAULT_BREAK_PRODUCT: 'DEFAULT_BREAK_PRODUCT',
    DEFAULT_RETAIL: 'DEFAULT_RETAIL',
    UNSELECTED_BREAK_PRODUCTS: 'UNSELECTED_BREAK_PRODUCTS',
    APPLIED_FILTERS_QTY: 'APPLIED_FILTERS_QTY'
  },
  actions: {
    INIT: 'INIT',
    INIT_RETAIL_LIST: 'INIT_RETAIL_LIST',
    INIT_DIMENSION_FILTER: 'INIT_DIMENSION_FILTER',
    INIT_GRID: 'INIT_GRID',
    FETCH_RETAIL_LIST: 'FETCH_RETAIL_LIST',
    FETCH_BREAK_PRODUCTS: 'FETCH_BREAK_PRODUCTS',
    FETCH_STOCK_BREAK_GRID: 'FETCH_STOCK_BREAK_GRID',
    FETCH_RETAIL_STORE_LIST: 'FETCH_RETAIL_STORE_LIST',
    DOWNLOAD_STOCK_BREAK_TO_XLSX: 'DOWNLOAD_STOCK_BREAK_TO_XLSX',
    CHANGE_RETAIL: 'CHANGE_RETAIL',
    CHANGE_BREAK_PRODUCT: 'CHANGE_BREAK_PRODUCT',
    APPLY_STORE_FILTERS: 'APPLY_STORE_FILTERS'
  },
  mutations: {
    SET_RETAIL_LIST: 'SET_RETAIL_LIST',
    TOGGLE_GRID: 'TOGGLE_GRID',
    SET_BREAK_PRODUCTS: 'SET_BREAK_PRODUCTS',
    SET_GRID: 'SET_GRID',
    SET_SELECTED_RETAIL: 'SET_SELECTED_RETAIL',
    SET_SELECTED_BREAK_PRODUCT: 'SET_SELECTED_BREAK_PRODUCT',
    SET_CLIENT_DIMENSION_FILTER_KEY: 'SET_CLIENT_DIMENSION_FILTER_KEY',
    SET_STORE_FILTERS: 'SET_STORE_FILTERS',
    RESET_STATE: 'RESET_STATE'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const initState = () => {
  return {
    retailList: null,
    breakProducts: null,
    grid: null,
    selectedBreakProduct: null,
    selectedRetail: null,
    clientDimensionFilterKey: null,
    downloadingGrid: false,
    appliedStoreFilters: []
  }
}
const Index = {
  namespaced: true,
  state: initState(),
  getters: {
    [_types.getters.DEFAULT_RETAIL]: (state) => {
      return state.retailList[0]
    },
    [_types.getters.DEFAULT_BREAK_PRODUCT]: (state) => {
      return state.breakProducts
        ? state.breakProducts[0]
        : undefined
    },
    [_types.getters.UNSELECTED_BREAK_PRODUCTS]: (state) => {
      return state.breakProducts
        .filter(breakProduct => breakProduct.id !== state.selectedBreakProduct.id)
    },
    [_types.getters.APPLIED_FILTERS_QTY]: (state) => {
      return state.appliedStoreFilters.length
    }
  },
  mutations: {
    [_types.mutations.SET_BREAK_PRODUCTS] (state, breakProducts) {
      state.breakProducts = breakProducts
    },
    [_types.mutations.SET_RETAIL_LIST] (state, retailList) {
      state.retailList = retailList
    },
    [_types.mutations.SET_SELECTED_RETAIL] (state, selectedRetail) {
      state.selectedRetail = selectedRetail
    },
    [_types.mutations.SET_SELECTED_BREAK_PRODUCT] (state, selectedBreakProduct) {
      state.selectedBreakProduct = selectedBreakProduct
    },
    [_types.mutations.SET_GRID] (state, grid) {
      state.grid = grid
    },
    [_types.mutations.SET_CLIENT_DIMENSION_FILTER_KEY] (state, clientDimensionFilterKey) {
      state.clientDimensionFilterKey = clientDimensionFilterKey
    },
    [_types.mutations.SET_STORE_FILTERS] (state, storeFilters) {
      state.appliedStoreFilters = storeFilters
    },
    [_types.mutations.TOGGLE_GRID] (state) {
      state.downloadingGrid = !state.downloadingGrid
    },
    [_types.mutations.RESET_STATE] (state) {
      Object.assign(state, initState())
    }
  },
  actions: {
    async [_types.actions.INIT] ({ dispatch, commit }, clientDimensionFilterKey) {
      commit(_types.mutations.SET_CLIENT_DIMENSION_FILTER_KEY, clientDimensionFilterKey)
      await dispatch(_types.actions.INIT_RETAIL_LIST)
      await dispatch(_types.actions.INIT_DIMENSION_FILTER)
      await dispatch(_types.actions.INIT_GRID)
    },
    async [_types.actions.INIT_RETAIL_LIST] ({ dispatch, getters, commit }) {
      await dispatch(_types.actions.FETCH_RETAIL_LIST)
      const defaultRetail = getters[_types.getters.DEFAULT_RETAIL]
      commit(_types.mutations.SET_SELECTED_RETAIL, defaultRetail)
    },
    // TODO: Refactorizar este método
    async [_types.actions.INIT_DIMENSION_FILTER] ({ state, dispatch, getters, commit }) {
      const { selectedRetail, clientDimensionFilterKey } = state
      await dispatch(_types.actions.FETCH_BREAK_PRODUCTS, { retailId: selectedRetail.retail_id, clientDimensionFilterKey })
      const defaultBreakProduct = getters[_types.getters.DEFAULT_BREAK_PRODUCT]
      commit(_types.mutations.SET_SELECTED_BREAK_PRODUCT, defaultBreakProduct)
    },
    async [_types.actions.INIT_GRID] ({ dispatch, state }) {
      const { metadata: productMetadata, id: productFilterFieldValue } = state.selectedBreakProduct
      await dispatch(_types.actions.FETCH_STOCK_BREAK_GRID, { productFilterFieldKey: productMetadata.field, productFilterFieldValue })
    },
    async [_types.actions.FETCH_RETAIL_LIST] ({ commit }) {
      const retailList = await getRetailList()
      commit(_types.mutations.SET_RETAIL_LIST, retailList)
    },
    async [_types.actions.FETCH_BREAK_PRODUCTS] ({ commit }, { retailId, clientDimensionFilterKey }) {
      const breakProducts = await getBreakProductsByRetailId(retailId, clientDimensionFilterKey)
      commit(_types.mutations.SET_BREAK_PRODUCTS, breakProducts)
    },
    async [_types.actions.FETCH_STOCK_BREAK_GRID] ({ state, commit }, { productFilterFieldKey, productFilterFieldValue, storeIds = [] }) {
      commit(_types.mutations.TOGGLE_GRID)
      const stockBreakGrid = await getStockBreakGrid(state.selectedRetail.retail_id, productFilterFieldKey, productFilterFieldValue, storeIds)
      commit(_types.mutations.SET_GRID, stockBreakGrid)
      commit(_types.mutations.TOGGLE_GRID)
    },
    async [_types.actions.FETCH_RETAIL_STORE_LIST] ({ state }) {
      const retailStoreList = await getRetailStoreList(state.selectedRetail.retail_id)
      return retailStoreList
    },
    async [_types.actions.DOWNLOAD_STOCK_BREAK_TO_XLSX] (_) {
      await downloadStockBreakToXlsx()
    },
    async [_types.actions.CHANGE_RETAIL] ({ commit, dispatch }, retail) {
      commit(_types.mutations.SET_SELECTED_RETAIL, retail)
      await dispatch(_types.actions.INIT_DIMENSION_FILTER)
      await dispatch(_types.actions.INIT_GRID)
    },
    async [_types.actions.CHANGE_BREAK_PRODUCT] ({ commit, dispatch }, breakProduct) {
      commit(_types.mutations.SET_SELECTED_BREAK_PRODUCT, breakProduct)
      await dispatch(_types.actions.INIT_GRID)
    },
    async [_types.actions.APPLY_STORE_FILTERS] ({ state, dispatch, commit }, selectedStores) {
      commit(_types.mutations.SET_STORE_FILTERS, selectedStores)
      const { metadata: productMetadata, id: productFilterFieldValue } = state.selectedBreakProduct
      const storeIds = selectedStores.map(store => store.store_id)
      await dispatch(_types.actions.FETCH_STOCK_BREAK_GRID, { productFilterFieldKey: productMetadata.field, productFilterFieldValue, storeIds })
    }
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/stock_break/store/Index.js